<template>
    <div>
        <el-collapse>
            <el-collapse-item>
                <template slot="title">
                    <i class="header-icon el-icon-s-operation"></i>筛选
                    <span class="totalwrp">总条数:{{ total }}</span>
                </template>
                <div class="dataFilterWrap">
                    <el-row :gutter="8">
                        <!-- <el-col :span="4">
                            <el-button type="primary" @click="beforeAdd">添加</el-button>
                        </el-col> -->
                        <el-col :span="8">
                            <label>状态</label>
                            <el-select v-model="isdelete" placeholder="请选择">
                                <el-option value="" label="所有"></el-option>
                                <el-option :value="0" label="正常"></el-option>
                                <el-option :value="1" label="已删除"></el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="8">
                            <el-input type="text" v-model="keyword" placeholder="输入公司名关键字"></el-input>
                            <el-button type="success" round icon="el-icon-search" @click="searchKeyWord">筛选</el-button>
                        </el-col>
                    </el-row>
                </div>
            </el-collapse-item>
        </el-collapse>
        <el-table :data="agencyList" stripe fit tooltip-effect="dark">
            <el-table-column label="序号" width="100">
                <template slot-scope="scope">{{ scope.row._rowNumber }}</template>
            </el-table-column>
            <el-table-column label="账号" width="120" show-overflow-tooltip>
                <template slot-scope="scope">{{ scope.row.TravelCompany_Account }}</template>
            </el-table-column>
            <el-table-column label="名称" show-overflow-tooltip>
                <template slot-scope="scope">{{ scope.row.TravelCompany_Name }}</template>
            </el-table-column>
            <el-table-column label="营业执照" show-overflow-tooltip>
                <template slot-scope="scope"> {{ scope.row.TravelCompany_Number }}</template>
            </el-table-column>
            <el-table-column label="地址" show-overflow-tooltip>
                <template slot-scope="scope"> {{ scope.row.TravelCompany_Address }}</template>
            </el-table-column>
            <el-table-column label="电话" show-overflow-tooltip>
                <template slot-scope="scope"> {{ scope.row.TravelCompany_Phone }}</template>
            </el-table-column>
            <el-table-column label="状态" width="120" show-overflow-tooltip>
                <template slot-scope="scope">{{ switchType(scope.row.TravelCompany_Delete) }}</template>
            </el-table-column>
            <!-- <el-table-column label="操作" width="400" fixed="right">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" plain @click="edtPolicyAct(scope.row)">修改</el-button>
                    <el-button v-if="scope.row.TravelCompany_Delete == 0" type="danger" size="mini" plain
                        @click="sendDelete(scope.row, 0)">删 除</el-button>
                    <el-button v-else type="success" size="mini" plain @click="sendDelete(scope.row)">启 用</el-button>
                    <el-button type="primary" size="mini" plain @click="getSuzu(scope.row)">属组</el-button>

                    <el-button type="primary" size="mini" plain @click="getCtraList(scope.row)">合同</el-button>
                    <el-popconfirm confirm-button-text="好的" cancel-button-text="再考虑" icon="el-icon-info"
                        icon-color="red" title="确定要重置密码吗？" @confirm="sendReset(scope.row)">
                        <el-button type="default" size="mini" plain slot="reference">重置密码</el-button>
                    </el-popconfirm>
                </template>
            </el-table-column> -->
        </el-table>
        <el-pagination background layout="prev, pager, next, jumper" :total="total" @current-change="setPageIndx">
        </el-pagination>

        <el-dialog :visible.sync="addPolicy" title="添加企业" width="77%" modal :close-on-click-modal="false">
            <div class="details-wrp">
                <el-row class="policyWrp">
                    <el-col :span="12">
                        <label>企业名称</label>
                        <el-input type="text" v-model="current.TravelCompany_Name"></el-input>
                    </el-col>
                    <el-col :span="12">
                        <label>营业执照</label>
                        <el-input type="text" v-model="current.TravelCompany_Number"></el-input>
                    </el-col>
                    <el-col :span="12">
                        <label>登陆账号（密码默认123456）</label>
                        <el-input type="text" v-model="current.TravelCompany_Account"></el-input>
                    </el-col>
                    <el-col :span="12">
                        <label>手机</label>
                        <el-input type="text" v-model="current.TravelCompany_Phone"></el-input>
                    </el-col>
                    <el-col :span="24"><label>地址</label>
                        <el-input type="textarea" :rows="2" v-model="current.TravelCompany_Address"></el-input>
                    </el-col>
                    <!-- <el-col :span="24"><label>备注</label>
                        <el-input type="textarea" :rows="3" v-model="current.TravelCompany_Remark"></el-input>
                    </el-col> -->
                </el-row>
                <div class="btm-btns">
                    <el-button plain round type="default" @click="cancelAdd">取消</el-button>
                    <el-button plain round type="primary" @click="sureAdd">确定</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="edtPolicy" title="修改企业" width="77%" modal :close-on-click-modal="false">
            <div class="details-wrp">
                <el-row class="policyWrp">
                    <el-col :span="12">
                        <label>企业名称</label>
                        <el-input type="text" v-model="current.TravelCompany_Name"></el-input>
                    </el-col>
                    <el-col :span="12">
                        <label>营业执照</label>
                        <el-input type="text" v-model="current.TravelCompany_Number"></el-input>
                    </el-col>
                    <el-col :span="12">
                        <label>登陆账号</label>
                        <el-input type="text" v-model="current.TravelCompany_Account"></el-input>
                    </el-col>
                    <el-col :span="12">
                        <label>手机</label>
                        <el-input type="text" v-model="current.TravelCompany_Phone"></el-input>
                    </el-col>
                    <el-col :span="24"><label>地址</label>
                        <el-input type="textarea" :rows="2" v-model="current.TravelCompany_Address"></el-input>
                    </el-col>
                </el-row>
                <div class="btm-btns">
                    <el-button plain round type="default" @click="cancelEdt">取消</el-button>
                    <el-button plain round type="primary" @click="sureEdt">确定</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="addSZ" title="新增属组" width="77%" modal :close-on-click-modal="false">
            <div class="details-wrp">
                <el-row class="policyWrp">
                    <el-col :span="24">
                        <label>名称</label>
                        <el-input type="text" v-model="szCurrent.Policy_Name"></el-input>
                    </el-col>
                    <el-col :span="12">
                        <label>保费</label>
                        <el-input type="text" v-model="szCurrent.Policy_Money" placeholder="价格数"></el-input>
                    </el-col>
                    <el-col :span="12">
                        <label>责任险保费</label>
                        <el-input type="text" v-model="szCurrent.Policy_LiabilityMoney" placeholder="价格数"></el-input>
                    </el-col>
                    <el-col :span="24">
                        <label>产品描述</label>
                        <el-input type="text" v-model="szCurrent.Policy_Brief"></el-input>
                    </el-col>
                    <el-col :span="24"><label>产品特约</label>
                        <tinymce-editor v-model='szCurrent.Policy_Term' @input='setSzTerm' />
                    </el-col>
                </el-row>
                <div class="btm-btns">
                    <el-button plain round type="default" @click="cancelAddSz">取消</el-button>
                    <el-button plain round type="primary" @click="sureAddSz">确定</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="editsz" title="修改属组" width="77%" modal :close-on-click-modal="false">
            <div class="details-wrp">
                <el-row class="policyWrp">
                    <el-col :span="24">
                        <label>名称</label>
                        <el-input type="text" v-model="szCurrent.Policy_Name"></el-input>
                    </el-col>
                    <el-col :span="12">
                        <label>保费</label>
                        <el-input type="text" v-model="szCurrent.Policy_Money" placeholder="价格数"></el-input>
                    </el-col>
                    <el-col :span="12">
                        <label>责任险保费</label>
                        <el-input type="text" v-model="szCurrent.Policy_LiabilityMoney" placeholder="价格数"></el-input>
                    </el-col>
                    <el-col :span="24">
                        <label>产品描述</label>
                        <el-input type="text" v-model="szCurrent.Policy_Brief"></el-input>
                    </el-col>
                    <el-col :span="24"><label>产品特约</label>
                        <tinymce-editor v-model='szCurrent.Policy_Term' @input='setSzTerm' />
                    </el-col>
                </el-row>
                <div class="btm-btns">
                    <el-button plain round type="default" @click="cancelEditsz">取消</el-button>
                    <el-button plain round type="primary" @click="sureEditsz">确定</el-button>
                </div>
            </div>
        </el-dialog>
        <el-drawer title="属组" :visible.sync="supplementDrawer" size="77%">
            <el-button plain round type="primary" @click="beforeAddSuzu">新增属组</el-button>
            <el-table :data="szTable" fit>
                <el-table-column property="Policy_ID" label="ID" width="70"></el-table-column>
                <el-table-column property="Policy_Name" label="名称" width="110"></el-table-column>
                <el-table-column property="Policy_Money" label="保费" width="70"></el-table-column>
                <el-table-column property="Policy_Brief" label="产品描述" width="150"></el-table-column>
                <el-table-column property="Policy_Term" label="产品特约">
                    <template slot-scope="scope">
                        <div v-html="scope.row.Policy_Term"></div>
                    </template>
                </el-table-column>
                <!-- <el-table-column property="TravelCompany_Name" label="所属企业" width="80"></el-table-column> -->
                <el-table-column label="操作" width="320">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" plain @click="showChangeSz(scope.row)">修改</el-button>
                        <el-button type="primary" size="mini" plain
                            @click="deleteSz(scope.row.Policy_ID)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-drawer>


        <el-dialog :visible.sync="addCtra" title="新增合同" width="77%" modal :close-on-click-modal="false">
            <div class="details-wrp">
                <el-row class="policyWrp">
                    <el-col :span="24">
                        <label>合同名称</label>
                        <el-input type="text" v-model="ctraCurrent.Insurance_Destination"></el-input>
                    </el-col>
                    <el-col :span="12">
                        <label>开始时间</label>
                        <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                            v-model="ctraCurrent.Insurance_EffectStart" type="date" placeholder="选择日期">
                        </el-date-picker>
                    </el-col>
                    <el-col :span="12">
                        <label>结束时间</label>
                        <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                            v-model="ctraCurrent.Insurance_EffectEnd" type="date" placeholder="选择日期">
                        </el-date-picker>
                    </el-col>
                </el-row>
                <div class="btm-btns">
                    <el-button plain round type="default" @click="cancelAddCtra">取消</el-button>
                    <el-button plain round type="primary" @click="sureAddCtra">确定</el-button>
                </div>
            </div>
        </el-dialog>
        <!-- <el-dialog :visible.sync="editCtra" title="修改合同" width="77%" modal :close-on-click-modal="false">
            <div class="details-wrp">
                <el-row class="policyWrp">
                    <el-col :span="24">
                        <label>合同名称</label>
                        <el-input type="text" v-model="ctraCurrent.Insurance_Destination"></el-input>
                    </el-col>
                    <el-col :span="12">
                        <label>开始时间</label>
                        <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                            v-model="ctraCurrent.Insurance_EffectStart" type="date" placeholder="选择日期">
                        </el-date-picker>
                    </el-col>
                    <el-col :span="12">
                        <label>结束时间</label>
                        <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                            v-model="ctraCurrent.Insurance_EffectEnd" type="date" placeholder="选择日期">
                        </el-date-picker>
                    </el-col>
                </el-row>
                <div class="btm-btns">
                    <el-button plain round type="default" @click="cancelEditctra">取消</el-button>
                    <el-button plain round type="primary" @click="sureEditctra">确定</el-button>
                </div>
            </div>
        </el-dialog> -->
        <el-drawer title="合同" :visible.sync="contractDrawer" size="67%">
            <el-button plain round type="primary" @click="beforeAddCtra">新增合同</el-button>
            <el-table :data="ctraTable" fit>
                <el-table-column property="Insurance_ID" label="ID" width="70"></el-table-column>
                <el-table-column property="Insurance_Destination" label="合同名称" width="110"></el-table-column>
                <el-table-column property="Insurance_EffectStart" label="合同开始时间" width="110"></el-table-column>
                <el-table-column property="Insurance_EffectEnd" label="合同结束时间"></el-table-column>
                <el-table-column property="Insurance_Company" label="企业ID"></el-table-column>
                <el-table-column label="操作" width="320">
                    <template slot-scope="scope">
                        <!-- <el-button type="primary" size="mini" plain @click="showChangeCtra(scope.row)">修改</el-button> -->
                        <el-button type="primary" size="mini" plain
                            @click="deleteCtra(scope.row.Insurance_ID)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-drawer>
    </div>
</template>

<script>
import tinymceEditor from '../components/editor.vue'
export default {
    data() {
        return {
            agencyList: [],
            areaList: [],
            current: {
                TravelCompany_Account: "",
                TravelCompany_Address: "",
                TravelCompany_Number: "",
                TravelCompany_Name: "",
                TravelCompany_Phone: "",
            },
            szTable: [],
            ctraTable: [],
            addSZ: false,
            addCtra: false,
            ctraCurrent: {
                Insurance_Destination: "",
                Insurance_EffectStart: "",
                Insurance_EffectEnd: "",
                Insurance_Company: "",
            },
            szCurrent: {
                Policy_Name: "",
                Policy_Money: "",
                Policy_Brief: "",
                Policy_Term: "",
                Policy_LiabilityMoney: "",
            },
            products: "",
            isdelete: "",
            addPolicy: false,
            edtPolicy: false,
            editCtra: false,
            editsz: false,
            supplementDrawer: false,
            contractDrawer: false,
            keyword: "",
            pageindex: 1,
            pagesize: 10,
            total: 0,
            companyid: 0,
            travelArea: ""
        }
    },
    components: {
        tinymceEditor
    },
    mounted() {
        this.pullList()
    },
    methods: {
        setSzTerm(val) {
            // console.log("Policy_Term:", this.szCurrent.Policy_Term)
            // console.log("val:", val)
            this.szCurrent.Policy_Term = val
        },
        getSuzu(item) {
            this.szTable = []
            this.supplementDrawer = true
            this.companyid = item.TravelCompany_ID
            this.ipost("/AdminTravel/PolicyWelfare.ashx?type=select", {
                companyid: this.companyid
            }, (res) => {
                this.szTable = res.list
            })
        },
        getSuzuByID(id) {
            this.ipost("/AdminTravel/PolicyWelfare.ashx?type=select", {
                companyid: id
            }, (res) => {
                this.szTable = res.list
            })
        },
        getCtraList(item) {
            this.companyid = item.TravelCompany_ID
            this.ipost("/AdminTravel/InsuranceWelfare.ashx?type=select", {
                companyid: this.companyid
            }, res => {
                this.ctraTable = res.list.map(item => {
                    item.Insurance_EffectStart = item.Insurance_EffectStart.substr(0, 11)
                    item.Insurance_EffectEnd = item.Insurance_EffectEnd.substr(0, 11)
                    return item
                })
                this.contractDrawer = true
            })
        },
        getCtraListByID(id) {
            this.ipost("/AdminTravel/InsuranceWelfare.ashx?type=select", {
                companyid: id
            }, res => {
                this.ctraTable = res.list.map(item => {
                    item.Insurance_EffectStart = item.Insurance_EffectStart.substr(0, 11)
                    item.Insurance_EffectEnd = item.Insurance_EffectEnd.substr(0, 11)
                    return item
                })
                this.contractDrawer = true
            })
        },
        beforeAddSuzu() {
            this.addSZ = true
            this.szCurrent = {}
            this.szCurrent.Policy_Company = this.companyid
        },
        beforeAddCtra() {
            this.addCtra = true
            this.ctraCurrent = {}
        },
        sureAddSz() {
            this.szCurrent.Policy_Company = this.companyid
            this.ipost("/AdminTravel/PolicyWelfare.ashx?type=insert", {
                model: JSON.stringify(this.szCurrent)
            }, (res) => {
                this.addSZ = false
                this.getSuzuByID(this.companyid)
            })
        },
        sureAddCtra() {
            this.ctraCurrent.Insurance_Company = this.companyid
            this.ipost("/AdminTravel/InsuranceWelfare.ashx?type=insert", {
                model: JSON.stringify(this.ctraCurrent)
            }, (res) => {
                this.addCtra = false
                this.getCtraListByID(this.companyid)
            })
        },
        showChangeSz(item) {
            this.editsz = true
            this.szCurrent = item
        },
        showChangeCtra(item) {
            this.editCtra = true
            this.ctraCurrent = {
                ...item
            }
            this.ctraCurrent.Insurance_EffectStart = item.Insurance_EffectStart.substr(0, 11)
            this.ctraCurrent.Insurance_EffectEnd = item.Insurance_EffectEnd.substr(0, 11)
        },
        cancelEditsz() {
            this.editsz = false
        },
        cancelAddCtra() {
            this.addCtra = false
        },
        sureEditsz() {

            this.ipost("/AdminTravel/PolicyWelfare.ashx?type=update", {
                model: JSON.stringify(this.szCurrent)
            }, (res) => {
                this.editsz = false
                this.szCurrent = {}
                this.getSuzuByID(this.companyid)
            })
        },
        sureEditctra() {
            this.ipost("/AdminTravel/InsuranceWelfare.ashx?type=update", {
                model: JSON.stringify(this.ctraCurrent)
            }, (res) => {
                this.editCtra = false
                this.getCtraListByID(this.companyid)
            })
        },
        deleteSz(id) {
            this.$confirm("确定要删除吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                this.ipost("/AdminTravel/PolicyWelfare.ashx?type=delete", {
                    id: id
                }, (res) => {
                    this.$message("删除成功")
                    this.getSuzuByID(this.companyid)
                })
            });
        },
        deleteCtra(id) {
            this.$confirm("确定要删除吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                this.ipost("/AdminTravel/InsuranceWelfare.ashx?type=cancel", {
                    id: id
                }, (res) => {
                    this.$message("删除成功")
                    this.getCtraListByID(this.companyid)
                }
                )
            })
        },
        cancelAddSz() {
            this.addSZ = false
        },
        cancelEdt() {
            this.edtPolicy = false
        },
        cancelAdd() {
            this.addPolicy = false
        },
        cancelEditctra() {
            this.editCtra = false
        },
        checkGrpChange(e) {
            console.log(e)
        },
        checkSure() {

            if (this.current.TravelCompany_Name == "") {
                this.$message({
                    title: "提示",
                    message: "请输入名称"
                })
                return false
            }

            if (this.current.TravelCompany_CertNumber == "") {
                this.$message({
                    title: "提示",
                    message: "请输入营业执照号码"
                })
                return false
            }

            if (this.current.TravelCompany_Account == "") {
                this.$message({
                    title: "提示",
                    message: "请输入账户名称"
                })
                return false
            }


            return true

        },
        edtPolicyAct(itm) {
            this.current = { ...itm }
            this.edtPolicy = true
        },
        sureEdt() {
            if (this.checkSure() == false) return false
            this.ipost(
                "/AdminTravel/TravelCompany.ashx?type=update", {
                model: JSON.stringify(this.current)
            },
                (res) => {
                    console.log("修改成功 res:", res)
                    this.edtPolicy = false
                    this.pullList()
                }
            );
        },
        beforeAdd() {
            this.resetCurrent()
            this.addPolicy = true
        },
        resetCurrent() {
            this.current.TravelCompany_Account = "";
            this.current.TravelCompany_Address = "";
            this.current.TravelCompany_Name = "";
            this.current.TravelCompany_Number = "";
            this.current.TravelCompany_Password = "";
            this.current.TravelCompany_Phone = "";
        },
        sureAdd() {
            if (this.checkSure() == false) return false

            this.ipost(
                "/AdminTravel/TravelCompany.ashx?type=insert", {
                model: JSON.stringify(this.current)
            },
                (res) => {
                    // console.log("添加成功 res:", res)
                    this.addPolicy = false
                    this.pullList()
                }
            );
        },
        sendReset(itm) {
            itm.TravelCompany_Password = '49ba59abbe56e057'
            this.ipost(
                "/AdminTravel/TravelCompany.ashx?type=update", {
                model: JSON.stringify(itm)
            },
                (res) => {
                    // console.log("添加成功 res:", res)
                    this.pullList()
                    this.$message("密码重置成功!")
                }
            );
        },
        sendDelete(itm, n) {
            if (n == 0) {
                this.$confirm('确定删除该数据吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.ipost(
                        "/AdminTravel/TravelCompany.ashx?type=delete", {
                        id: itm.TravelCompany_ID,
                    },
                        (res) => {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.pullList()
                        }
                    );
                });
            }
            else {
                this.ipost(
                    "/AdminTravel/TravelCompany.ashx?type=delete", {
                    id: itm.TravelCompany_ID,
                },
                    (res) => {
                        this.pullList()
                    }
                );
            }
        },
        pullList() {
            this.ipost(
                "/AdminTravel/TravelCompany.ashx?type=selectbytravelcompanyarea", {
                keyword: this.keyword,
                isdelete: this.isdelete,
                pageindex: this.pageindex,
                pagesize: this.pagesize,
            },
                (res) => {
                    console.log("res:", res)
                    this.agencyList = res.list
                    this.total = res.count
                }
            );
        },

        switchType(num) {
            let texts = ""
            switch (Number(num)) {
                case 0:
                    texts = '正常';
                    break;
                case 1:
                    texts = '已删除';
                    break;
                case 3:
                    texts = '已冻结';
                    break;
                default:
                    texts = '空';
                    break
            }
            return texts
        },
        setPageIndx(pgindx) {
            this.pageindex = pgindx;
            this.pullList();
        },
        searchKeyWord() {
            this.pageindex = 1;
            this.pullList();
        },
    }
}
</script>

<style scoped>
.el-table table {
    width: 100%;
}

.cell button,
.dialog-footer .el-button {
    margin: 0 8px;
}

.search-wrp .el-input {
    width: 60%;
    margin-right: 10px;
}

.el-collapse-item .el-row {
    padding: 6px 12px;
}

.el-pagination {
    margin: 16px auto;
    text-align: center;
}

.el-dialog .el-select {
    width: 100%;
}

.btm-btns {
    margin-top: 25px;
    text-align: center;
}

.el-col {
    padding: 5px;
}

.el-col label {
    line-height: 2.5;
}

.dataFilterWrap .el-row .el-col {
    display: flex;
    justify-content: flex-start;
    align-items: center;
}

.dataFilterWrap .el-row .el-col label {
    display: block;
    width: 80px;
    padding-right: 2px;
}

.dataFilterWrap button {
    margin-left: 10px;
}

.search-wrp-top .el-col {
    display: flex;
    justify-content: center;
    align-items: center;
}

.order-details .el-input,
.order-details .el-select {
    width: 90%;
}

.order-details button {
    display: block;
    height: 40px;
    width: 90%;
}

.order-details label {
    display: block;
    line-height: 3;
}

.details-btn {
    text-align: center;
    padding-top: 20px;
}
</style>
